import React from 'react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import FloatingHelpButton from '../components/landing/FloatingHelpButton';
import ChatWidget from '../components/ChatWidget/ChatWidget';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-page">
      <Header />

      <div className="about-hero">
        <div className="container">
          <h1>About eHaazri</h1>
          <p>Revolutionizing Attendance Management with Smart Technology</p>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <section className="about-section">
            <h2>Our Story</h2>
            <p>
              eHaazri was born from a simple observation: traditional attendance systems are outdated,
              inefficient, and prone to manipulation. We set out to create a modern, intelligent solution
              that leverages cutting-edge technology to make attendance management effortless and accurate.
            </p>
            <p>
              Founded by a team of technology enthusiasts and HR professionals, eHaazri combines deep
              industry knowledge with innovative thinking to deliver a product that truly meets the needs
              of modern organizations.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Mission</h2>
            <p>
              To empower organizations with intelligent, reliable, and user-friendly attendance management
              solutions that save time, reduce costs, and enhance productivity. We believe that managing
              attendance should be simple, transparent, and fraud-proof.
            </p>
          </section>

          <section className="about-section">
            <h2>Our Vision</h2>
            <p>
              To become the global standard for smart attendance management, helping organizations of all
              sizes streamline their workforce management through innovation and technology excellence.
            </p>
          </section>

          <section className="about-section">
            <h2>Why Choose eHaazri?</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">🎯</div>
                <h3>Accurate & Reliable</h3>
                <p>Advanced facial recognition and geofencing ensure 100% accurate attendance tracking with zero manipulation.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⚡</div>
                <h3>Lightning Fast</h3>
                <p>Mark attendance in seconds with our intuitive mobile app. No more queues or manual registers.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📊</div>
                <h3>Powerful Insights</h3>
                <p>Real-time reports and analytics help you make data-driven decisions about your workforce.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🔒</div>
                <h3>Secure & Private</h3>
                <p>Enterprise-grade security ensures your data is always protected and compliant with regulations.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🌐</div>
                <h3>Cloud-Based</h3>
                <p>Access your attendance data anytime, anywhere, from any device with our cloud infrastructure.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">💰</div>
                <h3>Cost-Effective</h3>
                <p>Eliminate expensive hardware and reduce administrative overhead with our affordable solution.</p>
              </div>
            </div>
          </section>

          <section className="about-section">
            <h2>Our Values</h2>
            <div className="values-list">
              <div className="value-item">
                <h3>Innovation</h3>
                <p>We constantly push boundaries to deliver cutting-edge solutions.</p>
              </div>
              <div className="value-item">
                <h3>Integrity</h3>
                <p>We build trust through transparency and honest communication.</p>
              </div>
              <div className="value-item">
                <h3>Excellence</h3>
                <p>We are committed to delivering the highest quality products and services.</p>
              </div>
              <div className="value-item">
                <h3>Customer Success</h3>
                <p>Your success is our success. We're here to support you every step of the way.</p>
              </div>
            </div>
          </section>

          <section className="about-section cta-section">
            <h2>Ready to Transform Your Attendance Management?</h2>
            <p>Join thousands of organizations already using eHaazri to streamline their operations.</p>
            <a href="/haazri-frontend/#/register" className="cta-button">Get Started Today</a>
          </section>
        </div>
      </div>

      <Footer />
      <FloatingHelpButton />
      <ChatWidget />
    </div>
  );
};

export default AboutUs;
